import React from 'react';
import { Toolbar, Stack } from '@mui/material';

export interface MenuBarProps {
  leftItems?: React.ReactNode;
  rightItems?: React.ReactNode;
}

export const MenuBar: React.FC<MenuBarProps> = ({ leftItems, rightItems }) => {
  return (
    <Toolbar className='lex-menubar'>
      <Stack
        direction='row'
        spacing={2}
        alignItems='center'
        sx={{ flexGrow: 1 }}
      >
        {leftItems}
      </Stack>
      <Stack
        direction='row'
        spacing={2}
        alignItems='center'
      >
        {rightItems}
      </Stack>
    </Toolbar>
  );
};

export default MenuBar;
